import type { ReactNode } from "react";

/**
 * A SETTING THAT APPEARS BECAUSE ANOTHER SETTING WAS TURNED ON — animated, not snapped.
 *
 * The one caller shape today is حکم's کوت row, which is asked only where the suit-less calls are
 * on offer: on «تنظیمات میز» (a private host) and on the solo start screen. Both used to reveal it
 * in a single frame — see `.reveal` in `styles/theme.css` for the measurements and for why the
 * animation is on the grid ROWS rather than a fade.
 *
 * ⚠️ THE CHILD STAYS MOUNTED WHILE CLOSED, so the collapse animates too and a controlled child
 * keeps its state. `aria-hidden` + the stylesheet's `visibility` keep it out of the a11y tree and
 * the tab order in the meantime — a 0fr row is invisible but its contents are still focusable.
 */
export function Reveal({ open, children }: { open: boolean; children: ReactNode }): ReactNode {
  return (
    <div className="reveal" data-open={open ? "true" : "false"} aria-hidden={!open}>
      <div className="reveal__inner">{children}</div>
    </div>
  );
}
